import { useQuery } from '@tanstack/react-query';
import { fetchSupportRequestTypesApi } from './api';
import { RoleType } from 'common/types/server-api-dtos';
import { CommonServiceApiTags } from '../api-tags';
import { profileServiceAvailablePagesSelector } from 'common/services/profile-service/service-store/selectors';
import { useProfileStore } from 'common/services/profile-service/service-store/service-store';
import { useSupportRequestTypesStore } from './service-store/service-store';
import { userService } from 'common/utils/user-service';
import { ONE_MINUTE } from 'common/constants/common-time';
export var useSupportRequestTypesData = function () {
    var isAuth = userService.isLoggedIn();
    var availablePages = useProfileStore(profileServiceAvailablePagesSelector);
    var setPageContent = useSupportRequestTypesStore(function (state) { return state.setPageContent; });
    var data = useQuery({
        queryKey: [CommonServiceApiTags.SupportRequestTypes],
        enabled: isAuth && !!(availablePages === null || availablePages === void 0 ? void 0 : availablePages.isSupportRequestsEnabled) && userService.hasRole(RoleType.Basic),
        staleTime: ONE_MINUTE * 10,
        queryFn: function () {
            return fetchSupportRequestTypesApi();
        },
    }).data;
    if (data !== undefined) {
        setPageContent(data);
    }
};
